import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("audit_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [billing, setBilling] = useState(null);
  const [booting, setBooting] = useState(true);

  const refreshBilling = useCallback(async () => {
    try {
      const { data } = await api.get("/billing/me");
      setBilling(data);
      return data;
    } catch {
      setBilling(null);
      return null;
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("audit_token");
    if (!token) {
      setBooting(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        const u = { id: r.data.id, email: r.data.email, name: r.data.name, is_admin: !!r.data.is_admin };
        setUser(u);
        localStorage.setItem("audit_user", JSON.stringify(u));
        setBilling(r.data.billing || null);
      })
      .catch(() => {
        localStorage.removeItem("audit_token");
        localStorage.removeItem("audit_user");
        setUser(null);
      })
      .finally(() => setBooting(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("audit_token", data.token);
    localStorage.setItem("audit_user", JSON.stringify(data.user));
    setUser(data.user);
    refreshBilling();
    return data.user;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("audit_token", data.token);
    localStorage.setItem("audit_user", JSON.stringify(data.user));
    setUser(data.user);
    refreshBilling();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("audit_token");
    localStorage.removeItem("audit_user");
    setUser(null);
    setBilling(null);
  };

  return (
    <AuthCtx.Provider value={{ user, billing, refreshBilling, login, register, logout, booting }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
